module.exports = __webpack_public_path__ + "img/triangle-24px.1fde9af1.svg";